export default __webpack_public_path__ + "static/media/logo-text.fb341b32.svg";